import React, {PureComponent, ReactNode} from 'react';

import classNames from 'classnames';

import s from './step.scss';

export type StepType = {
    /* set step as active, you don't need set it manually if you set activeStep prop in ProgressBar */
    active?: boolean;
    /* set step as need attention */
    attention?: boolean;
    /* set step type */
    type?: 'small' | 'big';
    /* set title for step */
    title?: ReactNode; // eslint-disable-line react/no-unused-prop-types
    /* step content, it will be displayed under ProgressBar when step will be active */
    children?: ReactNode; // eslint-disable-line react/no-unused-prop-types
    withContent: boolean;
};

/**
 * Step component for progress bar
 */
export class Step extends PureComponent<StepType> {
    static displayName = 'Step';

    static defaultProps = {
        attention: false,
        children: '',
        title: '',
        type: 'big',
        withContent: false,
    };

    /**
     * Render component
     */
    render() {
        const {active, attention, type, withContent} = this.props;

        return (
            <div className={s.container}>
                <div
                    className={classNames(s.step, {
                        [s.active]: active && !attention,
                        [s.attention]: attention,
                        [s.small]: type === 'small' && !attention,
                        [s.withContent]: withContent,
                    })}
                />
            </div>
        );
    }
}
